import { createSlice } from "@reduxjs/toolkit";
import { fetchMsItemsThunk, createMsItemThunk, updateMsItemThunk, submitMsItemThunk, softDeleteMsItemThunk, uploadMsItemThunk } from "../action/item.action";
import { itemInitialState } from "src/models/master_data/item/item.dto";

export const msItemsSlice = createSlice({
    name: 'msItems',
    initialState: itemInitialState,
    reducers: {},
    extraReducers: (builder) => {

        // Get All Items
        builder
            .addCase(fetchMsItemsThunk.fulfilled, (state, action) => {
                console.log(action.payload)
                state.data = action.payload.data.data;
                state.pagination=action.payload.data.pagination
                state.loading = false;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(fetchMsItemsThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.errorMessage = action.payload as string;
            })
            .addCase(fetchMsItemsThunk.pending, (state) => {
                state.loading = true;
                state.error = false;
                state.errorMessage = null;
            });

        // Create Item
        builder
            .addCase(createMsItemThunk.fulfilled, (state, action) => {
                state.data.push(action.payload.data); 
                state.loading = false;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(createMsItemThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.errorMessage = action.payload as string;
            })
            .addCase(createMsItemThunk.pending, (state) => {
                state.loading = true;
                state.error = false;
                state.errorMessage = null;
            });

        // Update Item
        builder
            .addCase(updateMsItemThunk.fulfilled, (state, action) => {
                const index = state.data.findIndex(item => item.id === action.payload.data.id);
                if (index !== -1) {
                    state.data[index] = action.payload.data; 
                }
                state.loading = false;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(updateMsItemThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.errorMessage = action.payload as string;
            })
            .addCase(updateMsItemThunk.pending, (state) => {
                state.loading = true;
                state.error = false;
                state.errorMessage = null;
            });

        // Delete Item
        builder
            .addCase(softDeleteMsItemThunk.fulfilled, (state, action) => {
                state.data = state.data.filter(item => item.id !== action.payload.data.id);
                state.loading = false;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(softDeleteMsItemThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.errorMessage = action.payload as string;
            })
            .addCase(softDeleteMsItemThunk.pending, (state) => {
                state.loading = true;
                state.error = false;
                state.errorMessage = null;
            });
        // Upload Items
        builder
            .addCase(uploadMsItemThunk.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.loading = false;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(uploadMsItemThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.errorMessage = action.payload as string;
            })
            .addCase(uploadMsItemThunk.pending, (state) => {
                state.loading = true;
                state.error = false;
                state.errorMessage = null;
            });

        // Submit Items
        builder
            .addCase(submitMsItemThunk.fulfilled, (state, action) => {
                state.data = action.payload.data; 
                state.loading = false;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(submitMsItemThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.errorMessage = action.payload as string;
            })
            .addCase(submitMsItemThunk.pending, (state) => {
                state.loading = true;
                state.error = false;
                state.errorMessage = null;
            });

    },
});

export default msItemsSlice.reducer;
